export const environment = {
  production: false,
  baseUrl: 'https://mhsp-dev.unfpa.org',
  apiPath: '',
  csrfTokenUrl: 'https://mhsp-dev.unfpa.org/session/token',
  firebaseConfig: {
    apiKey: "AIzaSyCPTPbmabvAGvJ4Ba7dUZd5yN2tcAgOszQ",
    authDomain: "tuneme-web.firebaseapp.com",
    projectId: "tuneme-web",
    storageBucket: "tuneme-web.firebasestorage.app",
    messagingSenderId: "640800996782",
    appId: "1:640800996782:web:9635d4c456340de33b5c3f",
    measurementId: "G-EXY2T5DDM9"
  }
};
